import React from "react";
import AppText from "../AppText/AppText";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { cn } from "@/utils/cn";

interface CheckboxProps {
	label?: string;
	onChange?: any;
	name?: string;
	disabled?: boolean;
	isChecked?: boolean;
	value?: any;
	defaultValue?: any;
	description?: string;
	margin?: string;
	customStyle?: boolean;
	labelClassName?: string;
}

const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
	(
		{
			label,
			onChange,
			name,
			disabled,
			isChecked,
			value,
			defaultValue,
			description,
			margin,
			customStyle = false,
			labelClassName,
		},
		ref
	) => {
		const id = Math.floor(Math.random() * 10000) + "" + Date.now();
		const { t } = useTranslation();

		return (
			<>
				{!customStyle ? (
					<CheckboxContainer margin={margin}>
						<input
							checked={isChecked !== undefined ? isChecked : undefined}
							type="checkbox"
							name={name}
							onChange={onChange}
							disabled={disabled}
							ref={ref}
							value={value}
							defaultValue={defaultValue}
							id={id}
							className="checkbox"
						/>
						{label && (
							<label htmlFor={id}>
								<AppText margin="0 0 0 1rem">{t(label as any)}</AppText>
								{description && (
									<AppText margin="0.2rem 0 0 1rem" size="s" color="grayText">
										{t(description as any)}
									</AppText>
								)}
							</label>
						)}
					</CheckboxContainer>
				) : (
					<div className={cn("flex select-none", margin && `[margin:${margin}]`)}>
						<label className="flex items-center cursor-pointer w-full gap-2 group">
							<input
								type="checkbox"
								checked={isChecked !== undefined ? isChecked : undefined}
								name={name}
								onChange={onChange}
								disabled={disabled}
								ref={ref}
								value={value}
								defaultValue={defaultValue}
								id={id}
								className="w-4 h-4 cursor-pointer"
							/>
							<span
								className={cn(
									"text-sm text-gray-700 cursor-pointer",
									"transition-colors duration-200",
									"group-hover:text-gray-900",
									labelClassName
								)}
							>
								{label}
							</span>
						</label>
					</div>
				)}
			</>
		);
	}
);

export default Checkbox;

const CheckboxContainer = styled.div<{ margin?: string }>`
	display: flex;
	align-items: center;
	user-select: none;
	margin: ${(props) => props.margin || "0"};
`;
